import { capitalize } from 'lodash';

/**
 * @param name error name *ex. `not enough data provided`*. default is `something went wrong`
 * @param args data that will help to debug *ex. `{ name: undefined }`*
 * @returns `new Error('Not enough data provided! Please try again. name: undefined')`
 */
export const getError = (
  name: string = 'something went wrong',
  args: { [key: string]: any } = {},
) => {
  const message = `${capitalize(
    name,
  )}! Please try again or contact the support.`;

  const params = Object.keys(args).reduce((_params, key, i) => {
    const separator = i !== 0 ? ', ' : '';

    return `${_params}${separator}${key}: ${args[key]}`;
  }, '');

  return new Error(`${message} ${params}`);
};
